const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.3 17.38l-2.71 2.71H6.87l5.96-7.45c.22-.34.22-.77 0-1.11L6.87 4.09h9.72L19.3 6.8c.35.35.89.39 1.29.1a1 1 0 00.31-1.26l-2-4c-.17-.34-.52-.55-.9-.55H4c-.26 0-.52.11-.71.29S3 1.82 3 2.09v2c0 .2.06.39.17.55L9 12.09l-5.83 7.45c-.11.15-.17.35-.17.55v2c0 .26.11.52.29.71s.45.29.71.29h14c.38 0 .72-.21.89-.55l2-4a1 1 0 00-.31-1.26.976.976 0 00-1.28.1z"
});

const SvgEquation = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation.8724c8fe.svg";
export { ForwardRef as ReactComponent };